import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { map } from 'rxjs/operators';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class SegmentService {

  constructor(private http: HttpClient) { }
  getAll(query): any {
    return this.http.get<any[]>(API_URL + `segment`, {params: query});
  }
  create(data): any{
    return this.http
    .post(API_URL + 'segment', data)
      .pipe(map(res => {
        return res;
    }));
  }
  get(id): any {
    return this.http.get<any[]>(API_URL + `segment/` + id);
  }
  search(keyword): any {
  return this.http.get<any[]>(API_URL + `segment/search/` + keyword).pipe(map(res => {
    return res;
  }));
  }
  update(data, id): any{
    return this.http
    .put(API_URL + 'segment/' + id , data)
      .pipe(map(res => {
        return res;
    }));
  }

  active(id): any{
  return this.http
  .put(API_URL + 'segment/' + id + '/active/',null)
    .pipe(map(res => {
      return res;
  }));
}
inactive(id): any{
  return this.http
  .put(API_URL + 'segment/' + id + '/inactive/', null)
    .pipe(map(res => {
      return res;
  }));
}

  changeStatus(id, status): any{
    return this.http
    .put(API_URL + 'segment/' + id + '/' + status , null)
      .pipe(map(res => {
        return res;
    }));
  }

  changeStatusDelete(id, status): any{
    return this.http
    .delete(API_URL + 'segment/' + id + '/' + status )
      .pipe(map(res => {
        return res;
    }));
  }

  delete(id): any{
    return this.http
    .delete(API_URL + 'segment/' + id + '/delete')
      .pipe(map(res => {
        return res;
    }));
  }

  getAllTypesEnum(): any {
    return this.http.get<any[]>(API_URL + `segment-types/types`);
  }

  getAllTypes(query): any {
    return this.http.get<any[]>(API_URL + `segment-types`, {params: query});
  }
  createType(data): any{
    return this.http
    .post(API_URL + 'segment-types', data)
      .pipe(map(res => {
        return res;
    }));
  }
  getType(id): any {
    return this.http.get<any[]>(API_URL + `segment-types/` + id);
  }
  searchType(keyword): any {
  return this.http.get<any[]>(API_URL + `segment-types/search/` + keyword).pipe(map(res => {
    return res;
  }));
  }
  updateType(data, id): any{
    return this.http
    .put(API_URL + 'segment-types/' + id , data)
      .pipe(map(res => {
        return res;
    }));
  }

  activeType(id): any{
  return this.http
  .put(API_URL + 'segment-types/' + id + '/active/',null)
    .pipe(map(res => {
      return res;
  }));
}
inactiveType(id): any{
  return this.http
  .put(API_URL + 'segment-types/' + id + '/inactive/', null)
    .pipe(map(res => {
      return res;
  }));
}

  changeStatusType(id, status): any{
    return this.http
    .put(API_URL + 'segment-types/' + id + '/' + status , null)
      .pipe(map(res => {
        return res;
    }));
  }

  changeStatusDeleteType(id, status): any{
    return this.http
    .delete(API_URL + 'segment-types/' + id + '/' + status )
      .pipe(map(res => {
        return res;
    }));
  }

  deleteType(id): any{
    return this.http
    .delete(API_URL + 'segment-types/' + id + '/delete')
      .pipe(map(res => {
        return res;
    }));
  }
}
